<template>
    <el-dialog :append-to-body="true" :visible.sync="setScore" v-if="setScore" custom-class="setScore xes-dialog" top="0" :title="headTitle" :close-on-press-escape="false" :close-on-click-modal="false">
        <!-- 题组批量设置得分、材料题批量设置得分 -->
        <div class="setScore_main" v-if="currentNode.length==1||testInfo.material_id">
            <p class="row">
                <label>{{labelTitle}}</label>
                <input class="setScore_input" type="text" v-model="aloneScoreNum" @input="aloneScore($event)" maxlength="4">
                <label>分*{{groupNum}}题</label>
            </p>
            <p class="row">
                <label>共计：</label>
                <label>{{sum}}分</label>
            </p>
        </div>
        <!-- 单题设置得分 -->
        <div class="setScore_main" v-else>
            <p class="row">
                <label>{{labelTitle}}</label>
                <input class="setScore_input" type="text" v-model="aloneScoreNum" @input="aloneScore($event)" maxlength="4">
                <label>分</label>
            </p>
        </div>
        <el-button size="small" type="primary" :disabled="setScoreBtn" @click="setScoreSubmit">确定</el-button>
    </el-dialog>
</template>

<script>
import $store from '../store'
import utils from './utils'
export default {
    props:['scoretype'],
    data () {
        return {
            aloneScoreNum:0//分数
        }
    },
    methods: {
        aloneScore(ev){//过滤输入内容
            if(this.scoretype == 'float'){
                this.aloneScoreNum = ev.target.value.replace(/[^.0-9]/g,'')
            }else{
                this.aloneScoreNum = ev.target.value.replace(/[^0-9]/g,'')
            }
        },
        setScoreSubmit(){//设置得分提交
            $store.commit('SETTOPICSCORE',Number(this.aloneScoreNum))
            this.setScore = false
        }
    },
    computed: {
        assemblyData(){
            return $store.state.assemblyData
        },
        currentNode(){
            return $store.state.currentNode
        },
        segment_list(){
            return $store.state.segment_list
        },
        setScore:{//设置得分视图
            set(){
                $store.commit('SETSCORESHOW')
            },
            get(){
                this.aloneScoreNum = this.testInfo.test_score ? this.testInfo.test_score : ''
                return $store.state.setScoreShow
            }
        },
        headTitle(){//头标题
            let title = ''
            if(this.currentNode.length>1){
                title = '分数设置：'
                let name = this.assemblyData.segment_list[this.currentNode[0]].name
                name = name.length>18?name.slice(0,17)+'...':name
                title += name
            }else{
                title = '批量设置得分'
            }
            return title
        },
        labelTitle(){//题标题
            let title = ''
            if(this.currentNode.length == 1){//题组批量设置得分
                title = this.assemblyData.segment_list[this.currentNode[0]].name
            }
            if(this.currentNode.length == 2){//单题或者材料题批量设置得分
                let test = this.segment_list[this.currentNode[0]].questions[this.currentNode[1]]
                if(test.material_id){
                    title = '材料题'
                }else{
                    title = this.segment_list[this.currentNode[0]].questions[this.currentNode[1]].type_name
                }
            }
            if(this.currentNode.length == 3){//材料单题设置得分
                title = this.segment_list[this.currentNode[0]].questions[this.currentNode[1]].question_list[this.currentNode[2]].type_name
            }
            return title
        },
        testInfo(){//题信息
            let test = {}
            if(this.currentNode.length == 2){
                test = this.assemblyData.segment_list[this.currentNode[0]].questions[this.currentNode[1]]
            }
            if(this.currentNode.length == 3){
                test = this.assemblyData.segment_list[this.currentNode[0]].questions[this.currentNode[1]].question_list[this.currentNode[2]]
            }
            return test
        },
        setScoreBtn(){//button锁定
            let btn = true
            if(!isNaN(this.aloneScoreNum)&&this.aloneScoreNum!=0){
                btn = false
            }
            return btn
        },
        groupNum(){//批量设置题数
            let num = 0
            if(this.currentNode.length == 1){
                this.assemblyData.segment_list[this.currentNode[0]].questions.forEach(el=>{
                    if(el.material_id){
                        num += el.question_list.length
                    }else{
                        num ++
                    }
                })
            }
            if(this.testInfo.material_id){
                num = this.testInfo.question_list.length
            }
            return num
        },
        sum(){
            return utils.formatNum(this.groupNum*this.aloneScoreNum,2)
        }
    }
}
</script>




// WEBPACK FOOTER //
// packages/question-assembly/src/setScore.vue